import { render } from "./CircularPagination.vue?vue&type=template&id=98c81c50"
import script from "./CircularPagination.vue?vue&type=script&lang=js"
export * from "./CircularPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__